import { colors } from '@flowwai-frontend/shared/style-guide'

export const leadDetailsRouteTheme = {
   light: {
      leadDetailsHeaderController: {
         borderColor: 'border-gray-300',
         backgroundColor: 'bg-base-white',
         salesPipelineColor: 'text-gray-600',
         noNameAvatarBgColor: 'bg-gray-100',
         noNameAvatarTextColor: 'tex-gray-600'
      },
      leadDetailsBody: {
         backgroundColor: 'bg-gray-100'
      },
      leadDetailsController: {
         backgroundColor: 'bg-gray-300',
         borderColor: 'border-gray-300',
         leadGofOverviewCard: {
            backgroundColor: 'bg-base-white',
            leadGofHeaderName: {
               color: 'text-gray-900'
            },
            leadOverViewFieldDisplayName: {
               color: 'text-gray-500'
            },
            leadOverViewFieldDisplayValue: {
               color: 'text-gray-800'
            },
            leadOverViewWhatsappFieldDisplayValue: {
               color: 'text-primary-600'
            },
            leadOverViewFieldIconColor: colors['primary-600'],
            edit: {
               color: 'text-primary-600',
               backgroundColor: 'bg-transparent'
            }
         },
         contactDetails: {
            contactTextColor: 'text-gray-900',
            viewDetailsTextColor: 'text-primary-600'
         }
      },
      leadAccessDeniedView: {
         headerColor: 'text-gray-900',
         leadAvatarBgColor: 'bg-base-white',
         leadNameColor: 'text-gray-700',
         leadAvatarBorderColor: 'border-gray-300',
         descriptionColor: 'text-gray-600'
      },
      leadDetailsTabsController: {
         leadDetailsTextColor: 'text-gray-600'
      },
      sideBar: {
         backgroundColor: 'bg-base-white',
         borderColor: 'border-gray-200'
      },
      plusIcon: {
         color: colors['base-white']
      },
      leadDetailsNoDataView: {
         backgroundColor: 'bg-base-white'
      },
      alertDialogView: {
         backgroundColor: 'bg-base-white'
      },
      createTaskView: {
         checkSquareIconFillColor: colors['gray-600']
      },
      alarmClockIconColor: colors['primary-600'],
      updateLeadMenu: {
         customOptionHoverBgColor: 'hover:bg-gray-50',
         focusBgColor: 'bg-gray-50',
         selectedBgColor: 'bg-gray-50',
         tickIconColor: colors['primary-600']
      },
      expandableLeadFieldCard: {
         cardTitleColor: 'text-gray-700',
         leftBorderColor: 'bg-primary-600',
         cardBgColor: 'bg-base-white',
         editButtonColor: 'text-primary-600',
         editIconColor: colors['primary-600'],
         chevronIconColor: colors['gray-500'],
         fieldNameColor: 'text-gray-500',
         fieldValueColor: 'text-gray-800',
         verticalLineColor: 'text-gray-300',
         phoneNumberTextColor: 'text-primary-600',
         phoneNumberIconColor: colors['primary-600'],
         phoneNumberDisabledTextColor: 'text-gray-800',
         dateColor: 'text-gray-800',
         URLTextColor: 'text-primary-600',
         remainingCountColor: 'text-gray-800',
         separatorBgColor: 'bg-gray-300'
      },
      expandableCompletedTaskCard: {
         cardTitleColor: 'text-gray-900',
         cardDescriptionColor: 'text-gray-500',
         cardBgColor: 'bg-base-white',
         chevronIconColor: colors['gray-500'],
         remarkContentColor: 'text-gray-800',
         remarkTitleColor: 'text-gray-500',
         audioLabelColor: 'text-gray-800',
         audioAddedDateColor: 'text-gray-600'
      },
      refreshIconColor: colors['error-700'],
      leadRemarksCard: {
         selectedCardBorder: 'border-primary-300',
         documentAttachmentIconStrokeColor: colors['primary-600'],
         documentAttachmentIconFillColor: colors['blue-50'],
         documentTitleTextColor: 'text-gray-700',
         documentTypeTextColor: 'text-gray-500'
      },
      leadOverViewCard: {
         cardBgColor: 'bg-base-white',
         titleTextColor: 'text-gray-700',
         cardBorderColor: 'border-gray-300',
         salesPipeLineTextColor: 'text-gray-600',
         noAssigneeAvatarBgColor: 'bg-gray-100',
         noAssigneeAvatarTextColor: 'tex-gray-600'
      },
      suggestedTasks: {
         cardHoverBgColor: 'bg-gray-50'
      },
      dealCardDateColor: 'text-gray-500',
      deals: {
         rockerIconColor: colors['gray-700']
      },
      linkedContactCard: {
         linkedContactTextColor: 'text-gray-700',
         borderColor: 'border-gray-300',
         contactTitleTextColor: 'text-gray-700',
         bgColor: 'bg-base-white',
         hoverBorderColor: 'hover:border-gray-300',
         contactDescriptionTextColor: 'text-gray-600',
         phoneIconColor: colors['gray-500']
      }
   },
   dark: {}
}
